export default {
  playBtn: 'パーティクルエフェクトを再生する',
  stopBtn: 'パーティクルエフェクトを一時停止する',
}
